module.exports = __webpack_public_path__ + "static/media/riverfolk3.650e1e25.jpg";